<template>
<div>
    <v-container>
        <v-row>
            <v-col cols="12">
                <s-toolbar :color="'black'" dark label="Inventario Contable" class="tran"></s-toolbar>
                <v-card>
                    <v-row justify="center" style="margin-top: 4px; margin-left: 10px; margin: auto">
                        <v-col cols="12" lg="6" md="6">
                            <v-autocomplete
                                :items="listaInventarios"
                                :loading="loadingInventarios"
                                :disabled="loadingInventarios"
                                v-model="selectedInventario"
                                item-text="displayText"
                                item-value="CodigoInventario"
                                return-object
                                label="Código Inventario . . . . . ."
                                :menu-props="{ maxHeight: '400px' }"
                                dense
                                outlined
                                clearable>
                                <template v-slot:item="{ item }">
                                    <v-list-item-content>
                                        <v-list-item-title>{{ item.CodigoInventario }}</v-list-item-title>
                                    </v-list-item-content>
                                </template>
                                <template v-slot:selection="{ item, index }">
                                    <span v-if="index === 0">{{ item.CodigoInventario }} - {{ formatDate(item.FechaRegistro) }}</span>
                                </template>
                            </v-autocomplete>
                        </v-col>
                        <v-col cols="6" lg="2" md="2" class="mt-0 pl-0">
                            <v-btn
                                :disabled="!selectedInventario || loadingData"
                                width="100%"
                                outlined
                                rounded
                                :color="'info'"
                                small
                                @click="buscar()">
                                <v-icon>mdi-magnify</v-icon>
                                {{ loadingData ? 'Cargando...' : 'Buscar' }}
                            </v-btn>
                        </v-col>
                        <v-col cols="6" lg="2" md="2" class="mt-0 pl-0">
                            <v-btn
                                :disabled="items.length === 0"
                                width="100%"
                                outlined
                                rounded
                                :color="'success'"
                                small
                                @click="exportarExcel()">
                                <v-icon>mdi-file-excel</v-icon>
                                Exportar
                            </v-btn>
                        </v-col>
                    </v-row>
                </v-card>
            </v-col>
        </v-row>

        <v-row no-gutters class="mt-3 kpi-row">
            <v-col cols="12" md="6" class="kpi-col-left pr-md-2">
                <v-card
                    class="kpi-card kpi-total mb-3"
                    rounded="lg"
                    elevation="2"
                    :class="{ 'kpi-skeleton': loadingData }">
                    <div class="kpi-card-top d-flex align-center pa-4" style="background: linear-gradient(135deg, #0284C7 0%, #075985 100%);">
                        <v-avatar size="52" color="white" class="flex-shrink-0" style="opacity: 0.95;">
                            <v-icon large color="#0284C7">mdi-domain</v-icon>
                        </v-avatar>
                        <div class="ml-4 white--text flex-grow-1">
                            <div class="text-subtitle-2 font-weight-medium text-uppercase" style="letter-spacing: 0.5px; opacity: 0.9;">
                                Total Inventario
                            </div>
                            <div class="text-h5 font-weight-bold mt-1">
                                Activo Fijo
                            </div>
                        </div>
                        <div class="d-none d-md-flex align-center justify-center white--text text-center ml-3" style="min-width: 90px;">
                            <div>
                                <div class="text-caption" style="opacity: 0.85;">Registros</div>
                                <div class="text-h6 font-weight-bold">
                                    <v-skeleton-loader v-if="loadingData" type="heading" width="60"></v-skeleton-loader>
                                    <template v-else>{{ formatKpiUnidades(kpiTotalInventario.unidades) }}</template>
                                </div>
                            </div>
                        </div>
                    </div>
                    <v-divider></v-divider>
                    <div class="pa-4 kpi-card-metrics">
                        <v-row no-gutters dense>
                            <v-col cols="12" md="6" class="text-center-md text-center pr-md-3 pr-0 mb-2 mb-md-0">
                                <div class="d-flex align-center justify-center-md justify-center">
                                    <v-icon small color="#0284C7" class="mr-2">mdi-cube-send</v-icon>
                                    <span class="text-overline font-weight-semibold text--darken-2" style="letter-spacing: 0.4px;">
                                        UNIDADES
                                    </span>
                                </div>
                                <v-skeleton-loader v-if="loadingData" type="heading" width="100%" class="mt-2"></v-skeleton-loader>
                                <div v-else class="text-h4 font-weight-black mt-1" style="color: #0C4A6E;">
                                    {{ formatKpiUnidades(kpiTotalInventario.unidades) }}
                                </div>
                            </v-col>
                            <v-col cols="12" md="6" class="text-center-md text-center pl-md-3 pl-0 kpi-divider-left">
                                <div class="d-flex align-center justify-center-md justify-center">
                                    <v-icon small color="#0F766E" class="mr-2">mdi-cash-multiple</v-icon>
                                    <span class="text-overline font-weight-semibold text--darken-2" style="letter-spacing: 0.4px;">
                                        VALOR EN LIBROS S/.
                                    </span>
                                </div>
                                <v-skeleton-loader v-if="loadingData" type="heading" width="100%" class="mt-2"></v-skeleton-loader>
                                <div v-else class="text-h4 font-weight-black mt-1" style="color: #0F766E;">
                                    {{ formatKpiDecimal(kpiTotalInventario.valor) }}
                                </div>
                            </v-col>
                        </v-row>
                    </div>
                </v-card>

                <v-card
                    class="kpi-card kpi-hallazgos"
                    rounded="lg"
                    elevation="2"
                    :class="{ 'kpi-skeleton': loadingData }">
                    <div class="kpi-card-top d-flex align-center pa-4" style="background: linear-gradient(135deg, #7C3AED 0%, #5B21B6 100%);">
                        <v-avatar size="48" color="white" class="flex-shrink-0" style="opacity: 0.95;">
                            <v-icon color="#7C3AED">mdi-magnify-scan</v-icon>
                        </v-avatar>
                        <div class="ml-4 white--text flex-grow-1">
                            <div class="text-subtitle-1 font-weight-bold">
                                Hallazgos del Inventario
                            </div>
                            <div class="text-caption text--lighten-2 mt-1" style="opacity: 0.85;">
                                Conciliación contable vs. conteo físico
                            </div>
                        </div>
                    </div>
                    <v-divider></v-divider>
                    <div class="pa-4">
                        <v-row no-gutters dense>
                            <v-col cols="12" md="6" class="pr-md-2 pr-0 mb-3 mb-md-0">
                                <div class="kpi-hallazgo-box rounded-lg pa-4" style="background: linear-gradient(135deg, #FFF1F2 0%, #FFE4E6 100%); border: 1px solid #FECDD3;">
                                    <div class="d-flex align-center mb-3">
                                        <v-chip
                                            small
                                            color="#DC2626"
                                            dark
                                            class="font-weight-bold flex-shrink-0 mr-2"
                                            label
                                            >
                                            <v-icon x-small left>mdi-alert-octagon</v-icon>
                                            FALTANTES
                                        </v-chip>
                                    </div>
                                    <div class="d-flex align-center mb-2">
                                        <v-icon small color="#B91C1C" class="mr-2">mdi-cube-send-outline</v-icon>
                                        <span class="text-caption font-weight-semibold grey--text text--darken-2">
                                            UNIDADES
                                        </span>
                                        <v-spacer></v-spacer>
                                        <v-skeleton-loader v-if="loadingData" type="heading" width="40"></v-skeleton-loader>
                                        <span v-else class="text-h6 font-weight-black" style="color: #991B1B;">
                                            {{ formatKpiUnidades(kpiFaltantes.unidades) }}
                                        </span>
                                    </div>
                                    <div class="d-flex align-center">
                                        <v-icon small color="#B91C1C" class="mr-2">mdi-cash-remove</v-icon>
                                        <span class="text-caption font-weight-semibold grey--text text--darken-2">
                                            VALOR EN LIBROS S/.
                                        </span>
                                        <v-spacer></v-spacer>
                                        <v-skeleton-loader v-if="loadingData" type="heading" width="80"></v-skeleton-loader>
                                        <span v-else class="text-subtitle-1 font-weight-black" style="color: #991B1B;">
                                            {{ formatKpiDecimal(kpiFaltantes.valor) }}
                                        </span>
                                    </div>
                                </div>
                            </v-col>
                            <v-col cols="12" md="6" class="pl-md-2 pl-0">
                                <div class="kpi-hallazgo-box rounded-lg pa-4" style="background: linear-gradient(135deg, #FFFBEB 0%, #FEF3C7 100%); border: 1px solid #FDE68A;">
                                    <div class="d-flex align-center mb-3">
                                        <v-chip
                                            small
                                            color="#B45309"
                                            dark
                                            class="font-weight-bold flex-shrink-0 mr-2"
                                            label
                                            >
                                            <v-icon x-small left>mdi-alert-decagram</v-icon>
                                            SOBRANTES
                                        </v-chip>
                                    </div>
                                    <div class="d-flex align-center mb-2">
                                        <v-icon small color="#B45309" class="mr-2">mdi-cube-send-outline</v-icon>
                                        <span class="text-caption font-weight-semibold grey--text text--darken-2">
                                            UNIDADES
                                        </span>
                                        <v-spacer></v-spacer>
                                        <v-skeleton-loader v-if="loadingData" type="heading" width="40"></v-skeleton-loader>
                                        <span v-else class="text-h6 font-weight-black" style="color: #92400E;">
                                            {{ formatKpiUnidades(kpiSobrantes.unidades) }}
                                        </span>
                                    </div>
                                    <div class="d-flex align-center">
                                        <v-icon small color="#B45309" class="mr-2">mdi-cash-plus</v-icon>
                                        <span class="text-caption font-weight-semibold grey--text text--darken-2">
                                            VALOR EN LIBROS S/.
                                        </span>
                                        <v-spacer></v-spacer>
                                        <v-skeleton-loader v-if="loadingData" type="heading" width="80"></v-skeleton-loader>
                                        <span v-else class="text-subtitle-1 font-weight-black" style="color: #92400E;">
                                            {{ formatKpiDecimal(kpiSobrantes.valor) }}
                                        </span>
                                    </div>
                                </div>
                            </v-col>
                        </v-row>
                    </div>
                </v-card>
            </v-col>

            <v-col cols="12" md="6" class="kpi-col-right pl-md-2 mt-3 mt-md-0">
                <v-card
                    class="kpi-card kpi-estados h-100"
                    rounded="lg"
                    elevation="2"
                    :class="{ 'kpi-skeleton': loadingData }">
                    <div class="pa-3">
                        <v-skeleton-loader v-if="loadingData" type="table" class="mb-2"></v-skeleton-loader>
                        <template v-else>
                            <!-- 🔹 Encabezado con indicador de filtro activo -->
                            <div class="d-flex align-center justify-space-between mb-2 px-1">
                                <div class="text-caption grey--text text--darken-2">
                                    <v-icon x-small class="mr-1">mdi-filter-variant</v-icon>
                                    Clic en una fila para filtrar la tabla
                                </div>
                                <v-chip
                                    v-if="selectedEstadoKey"
                                    x-small
                                    color="#0F766E"
                                    dark
                                    close
                                    @click:close="selectedEstadoKey = null">
                                    <v-icon x-small left>mdi-filter</v-icon>
                                    {{ estadoSeleccionadoLabel }}
                                </v-chip>
                            </div>
                            <div class="kpi-estados-table rounded-lg overflow-hidden" style="border: 1px solid #E2E8F0;">
                                <table class="kpi-table w-100">
                                    <thead>
                                        <tr>
                                            <th
                                                class="text-left pa-3"
                                                style="background: linear-gradient(180deg, #0F766E, #0F5E57); color: #fff; font-weight: 600; font-size: 11px; letter-spacing: 0.3px; text-transform: uppercase; width: 30%;">
                                                Estado
                                            </th>
                                            <th
                                                class="text-center pa-3"
                                                style="background: linear-gradient(180deg, #0F766E, #0F5E57); color: #fff; font-weight: 600; font-size: 11px; letter-spacing: 0.3px; text-transform: uppercase; width: 18%;">
                                                Unidades
                                            </th>
                                            <th
                                                class="text-right pa-3"
                                                style="background: linear-gradient(180deg, #0F766E, #0F5E57); color: #fff; font-weight: 600; font-size: 11px; letter-spacing: 0.3px; text-transform: uppercase; width: 30%;">
                                                Valor en Libros S/.
                                            </th>
                                            <th
                                                class="text-center pa-3"
                                                style="background: linear-gradient(180deg, #0F766E, #0F5E57); color: #fff; font-weight: 600; font-size: 11px; letter-spacing: 0.3px; text-transform: uppercase; width: 22%;">
                                                %
                                            </th>
                                        </tr>
                                    </thead>
                                    <tbody>
                                        <tr
                                            v-for="(st, idx) in kpiEstadosTableRows"
                                            :key="st.key"
                                            class="kpi-estados-row"
                                            :class="{ 'kpi-estado-selected': selectedEstadoKey === st.key }"
                                            :style="{ animationDelay: (idx * 80) + 'ms', background: idx % 2 === 0 ? '#FFFFFF' : '#F8FAFC' }"
                                            @click="toggleEstadoFiltro(st.key)">
                                            <td class="pa-3" style="vertical-align: middle;">
                                                <div class="d-flex align-center">
                                                    <v-icon
                                                        v-if="selectedEstadoKey === st.key"
                                                        small
                                                        color="#0F766E"
                                                        class="mr-2">mdi-filter-variant</v-icon>
                                                    <v-avatar size="32" class="mr-3 flex-shrink-0" :color="st.bg" style="border: 1px solid;" :style="{ borderColor: st.border }">
                                                        <v-icon small :color="st.color">{{ st.icon }}</v-icon>
                                                    </v-avatar>
                                                    <div>
                                                        <div class="text-body-2 font-weight-bold" :style="{ color: st.color }">
                                                            {{ st.label }}
                                                        </div>
                                                    </div>
                                                </div>
                                            </td>
                                            <td class="pa-3 text-center" style="vertical-align: middle;">
                                                <span class="text-subtitle-1 font-weight-bold text--darken-3">
                                                    {{ formatKpiUnidades(st.unidades) }}
                                                </span>
                                            </td>
                                            <td class="pa-3 text-right" style="vertical-align: middle;">
                                                <span class="text-subtitle-1 font-weight-bold text--darken-3 tabular-nums">
                                                    {{ formatKpiDecimal(st.valor) }}
                                                </span>
                                            </td>
                                            <td class="pa-3" style="vertical-align: middle;">
                                                <div class="d-flex align-center">
                                                    <v-progress-linear
                                                        :model-value="st.porcentaje"
                                                        color="rgba(15,118,110,0.1)"
                                                        height="18"
                                                        rounded
                                                        background-opacity="0"
                                                        class="mr-2 flex-grow-1"
                                                        style="height: 24px !important;">
                                                        <template v-slot:default="{ value }">
                                                            <div
                                                                class="d-flex align-center justify-end px-2 fill-height rounded"
                                                                :style="{
                                                                    width: (st.porcentaje || 0) + '%',
                                                                    background: st.color + '22',
                                                                    borderLeft: '3px solid ' + st.color,
                                                                    minWidth: st.porcentaje > 0 ? '42px' : '0',
                                                                }">
                                                                <span
                                                                    class="text-caption font-weight-black"
                                                                    :style="{ color: st.color, fontSize: '11px' }">
                                                                    {{ st.porcentaje }}%
                                                                </span>
                                                            </div>
                                                        </template>
                                                    </v-progress-linear>
                                                </div>
                                            </td>
                                        </tr>
                                    </tbody>
                                    <tfoot>
                                        <tr>
                                            <td class="pa-3" style="background: linear-gradient(90deg, #ECFDF5 0%, #CCFBF1 100%); border-top: 2px solid #0F766E;">
                                                <div class="d-flex align-center">
                                                    <v-icon color="#0F766E" class="mr-2">mdi-sigma</v-icon>
                                                    <span class="text-subtitle-2 font-weight-black" style="color: #0F766E;">TOTAL</span>
                                                </div>
                                            </td>
                                            <td class="pa-3 text-center" style="background: linear-gradient(90deg, #ECFDF5 0%, #CCFBF1 100%); border-top: 2px solid #0F766E;">
                                                <span class="text-subtitle-1 font-weight-black" style="color: #0F766E;">
                                                    {{ formatKpiUnidades(kpiEstados.total.unidades) }}
                                                </span>
                                            </td>
                                            <td class="pa-3 text-right" style="background: linear-gradient(90deg, #ECFDF5 0%, #CCFBF1 100%); border-top: 2px solid #0F766E;">
                                                <span class="text-subtitle-1 font-weight-black tabular-nums" style="color: #0F766E;">
                                                    {{ formatKpiDecimal(kpiEstados.total.valor) }}
                                                </span>
                                            </td>
                                            <td class="pa-3 text-center" style="background: linear-gradient(90deg, #ECFDF5 0%, #CCFBF1 100%); border-top: 2px solid #0F766E;">
                                                <v-chip small color="#0F766E" dark label class="font-weight-black">
                                                    100%
                                                </v-chip>
                                            </td>
                                        </tr>
                                    </tfoot>
                                </table>
                            </div>
                        </template>
                    </div>
                </v-card>
            </v-col>
        </v-row>

        <v-card flat class="mt-3">
            <v-divider></v-divider>
            <v-row justify="center">
                <v-col cols="12" lg="12" md="12" class="mt-3">
                    <!-- 🔹 chip de filtro activo arriba de la tabla -->
                    <div v-if="selectedEstadoKey" class="mb-2 d-flex align-center px-2">
                        <v-chip
                            small
                            color="#0F766E"
                            dark
                            close
                            @click:close="selectedEstadoKey = null">
                            <v-icon x-small left>mdi-filter-variant</v-icon>
                            Filtrado por: {{ estadoSeleccionadoLabel }}
                        </v-chip>
                        <span class="ml-2 text-caption grey--text text--darken-1">
                            ({{ itemsFiltrados.length }} de {{ items.length }} registros)
                        </span>
                    </div>

                    <v-data-table
                        :headers="headers"
                        :items="itemsFiltrados"
                        :loading="loadingData"
                        dense
                        fixed-header
                        height="450px"
                        class="elevation-1 con-inventory-table"
                        :footer-props="{
                            showCurrentPage: true,
                            showFirstLastPage: true,
                            itemsPerPageOptions: [10, 25, 50,400],
                        }">
                        <template v-slot:no-data>
                            <div class="py-8 text-center">
                                <v-icon large color="grey lighten-1">mdi-clipboard-list-outline</v-icon>
                                <div class="mt-2 grey--text">
                                    {{ selectedEstadoKey ? 'No hay registros para esta condición' : 'Seleccione un inventario y haga clic en Buscar' }}
                                </div>
                            </div>
                        </template>
                        <template v-slot:header="{ props }">
                            <thead class="v-data-table-header">
                                <tr>
                                    <th
                                        v-for="header in props.headers"
                                        :key="header.value"
                                        class="text-center white--text"
                                        :style="{
                                            backgroundColor: header.bgColor || '#8B4513',
                                            minWidth: header.width + 'px',
                                            width: header.width + 'px',
                                            fontWeight: 'bold',
                                            fontSize: '12px',
                                            padding: '8px 4px',
                                            position: 'sticky',
                                            top: 0,
                                            zIndex: 2,
                                        }">
                                        <span>{{ header.text }}</span>
                                        <v-icon
                                            v-if="header.sortable"
                                            small
                                            class="ml-1"
                                            @click="props.sort(header)"
                                            style="cursor: pointer;">
                                            {{ props.options.sortBy[0] === header.value
                                                ? (props.options.sortDesc[0] ? 'mdi-arrow-down' : 'mdi-arrow-up')
                                                : 'mdi-sort-variant' }}
                                        </v-icon>
                                    </th>
                                </tr>
                            </thead>
                        </template>
                        <template v-slot:item="{ item }">
                            <tr>
                                <td v-for="header in headers" :key="header.value" class="text-center" :style="{ minWidth: header.width + 'px', width: header.width + 'px' }">
                                    <template v-if="header.value === 'ContImg'">
                                        <v-btn
                                            v-if="item[header.value] > 0"
                                            x-small
                                            icon
                                            color="info"
                                            @click="verEvidencias(item)"
                                            title="Ver evidencias">
                                            <v-icon>mdi-eye</v-icon>
                                        </v-btn>
                                        <span v-else></span>
                                    </template>
                                    <template v-else>
                                        {{ formatCell(item[header.value], header) }}
                                    </template>
                                </td>
                            </tr>
                        </template>
                    </v-data-table>
                </v-col>
            </v-row>
        </v-card>

        <v-dialog v-model="processing" v-if="processing" width="400">
            <v-card color="primary" dark>
                <v-card-text>
                    Esto puede tardar unos minutos, Por favor espere.
                    <v-progress-linear indeterminate color="white" class="mb-0 mt-3"></v-progress-linear>
                </v-card-text>
            </v-card>
        </v-dialog>

        <v-dialog v-model="dialogEvidencias" max-width="650" scrollable persistent>
            <v-card class="evidencia-card" elevation="6" rounded="lg">
                <v-card-title class="evidencia-header py-4 px-6">
                    <div class="d-flex align-center">
                        <v-icon large color="white" class="mr-3">mdi-image-multiple</v-icon>
                        <div>
                            <div class="text-h5 white--text font-weight-bold">Evidencias del Activo</div>
                            <div class="text-h8 white--text text--lighten-2 mt-1">
                                {{ dialogEvidenciaInfo }}
                            </div>
                        </div>
                    </div>
                    <v-spacer></v-spacer>
                    <v-btn icon dark @click="cerrarDialogEvidencias()">
                        <v-icon>mdi-close</v-icon>
                    </v-btn>
                </v-card-title>

                <v-divider></v-divider>

                <v-card-text class="evidencia-body pa-4" ref="evidenciaScroll">
                    <div v-if="loadingEvidencias" class="text-center py-12">
                        <v-progress-circular indeterminate color="#0284C7" size="48"></v-progress-circular>
                        <div class="mt-3 grey--text text--darken-1">Cargando evidencias...</div>
                    </div>

                    <div v-else-if="listaEvidencias.length === 0" class="text-center py-12">
                        <v-icon large color="grey lighten-1">mdi-folder-image-outline</v-icon>
                        <div class="mt-3 grey--text">No se encontraron evidencias para este activo.</div>
                    </div>

                    <div v-else class="evidencia-chat d-flex flex-column">
                        <div
                            v-for="(ev, index) in listaEvidencias"
                            :key="ev.IdReporte || index"
                            class="evidencia-message mb-4"
                            :style="{ animationDelay: (index * 60) + 'ms' }">
                            <div class="d-flex align-start">
                                <v-avatar size="40" color="#0284C7" class="mr-3 flex-shrink-0">
                                    <v-icon dark>mdi-account</v-icon>
                                </v-avatar>
                                <div class="evidencia-bubble flex-grow-1">
                                    <div class="evidencia-meta d-flex align-center mb-2">
                                        <span class="font-weight-bold text--darken-3 mr-2">
                                            {{ ev.Usuario || 'Sistema' }}
                                        </span>
                                        <v-chip
                                            v-if="ev.Esquema"
                                            x-small
                                            outlined
                                            color="#0F766E"
                                            class="mr-2"
                                            label>
                                            Esq: {{ ev.Esquema }}
                                        </v-chip>
                                        <v-chip
                                            v-if="ev.Mejora"
                                            x-small
                                            outlined
                                            color="#B45309"
                                            label>
                                            Mej: {{ ev.Mejora }}
                                        </v-chip>
                                        <v-spacer></v-spacer>
                                        <span class="text-caption grey--text text--darken-1">
                                            {{ formatDateTimeChat(ev.FechaRegistro) }}
                                        </span>
                                    </div>

                                    <div
                                        v-if="getImageSrc(ev.ImagenBase64)"
                                        class="evidencia-image-wrapper mb-3"
                                        @click="abrirImagenCompleta(ev.ImagenBase64)">
                                        <v-img
                                            :src="getImageSrc(ev.ImagenBase64)"
                                            alt="Evidencia"
                                            contain
                                            height="280"
                                            class="evidencia-img rounded-lg"
                                            :lazy-src="'data:image/svg+xml;utf8,<svg xmlns=%22http://www.w3.org/2000/svg%22 viewBox=%220 0 100 100%22><rect fill=%22%23E0E7FF%22 width=%22100%22 height=%22100%22/><text x=%2250%22 y=%2250%22 text-anchor=%22middle%22 fill=%22%239CA3AF%22 font-size=%228%22 dy=%22.3em%22>Cargando...</text></svg>'">
                                            <template v-slot:placeholder>
                                                <div class="d-flex align-center justify-center fill-height grey lighten-3 rounded-lg">
                                                    <v-progress-circular indeterminate color="#0284C7" width="2" size="32"></v-progress-circular>
                                                </div>
                                            </template>
                                            <template v-slot:error>
                                                <div class="d-flex flex-column align-center justify-center fill-height grey lighten-4 rounded-lg pa-5" style="min-height: 200px;">
                                                    <v-icon size="48" color="grey darken-1" class="mb-3">mdi-image-broken</v-icon>
                                                    <div class="text-body-2 grey--text text--darken-2 text-center mb-2">
                                                        No se pudo cargar la vista previa
                                                    </div>
                                                    <v-btn
                                                        small
                                                        color="#0284C7"
                                                        rounded
                                                        class="mt-1"
                                                        @click.stop="abrirImagenCompleta(ev.ImagenBase64)">
                                                        <v-icon x-small left>mdi-open-in-new</v-icon>
                                                        Abrir imagen
                                                    </v-btn>
                                                </div>
                                            </template>
                                        </v-img>
                                        <div class="evidencia-image-zoom">
                                            <v-icon small dark>mdi-magnify-plus</v-icon>
                                        </div>
                                    </div>

                                    <div
                                        v-if="ev.Observacion"
                                        class="evidencia-observacion pa-3 rounded-lg"
                                        style="white-space: pre-line; text-align: justify; hyphens: auto;">
                                        <div class="text-caption font-weight-bold text--darken-2 mb-1 text-uppercase">
                                            <v-icon x-small class="mr-1">mdi-comment-text-outline</v-icon>
                                            Observación
                                        </div>
                                        <div class="text-body-3 text--darken-3">{{ ev.Observacion }}</div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </v-card-text>

                <v-divider></v-divider>

                <v-card-actions class="px-6 py-3 grey lighten-4">
                    <div class="text-caption grey--text text--darken-2">
                        <v-icon x-small class="mr-1">mdi-information-outline</v-icon>
                        Total de registros: {{ listaEvidencias.length }}
                    </div>
                    <v-spacer></v-spacer>
                    <v-btn
                        outlined
                        rounded
                        color="grey darken-1"
                        @click="cerrarDialogEvidencias()"
                        small>
                        <v-icon left>mdi-close</v-icon>
                        Cerrar
                    </v-btn>
                </v-card-actions>
            </v-card>
        </v-dialog>
    </v-container>
</div>
</template>

<script>
import _sInventory from '@/services/Accounting/ConInventory.js'
import * as XLSX from "xlsx";
export default {
    props: {},
    components: {},
    data() {
        return {
            loadingInventarios: false,
            loadingData: false,
            processing: false,
            listaInventarios: [],
            selectedInventario: null,
            items: [],
            // estado del filtro por condición
            selectedEstadoKey: null,
            dialogEvidencias: false,
            loadingEvidencias: false,
            listaEvidencias: [],
            selectedItemEvidencia: null,
            headers: [
                { text: "Cód. Inventario", value: "CodigoInventario", width: 140, sortable: true, bgColor: "#0284C7" },
                { text: "Cód. Activo Inv.", value: "CodigoActivo_Inventario", width: 140, sortable: true, bgColor: "#0284C7" },
                { text: "Evidencias", value: "ContImg", width: 90, sortable: true, type: "number", bgColor: "#0284C7" },
                { text: "Cantidad", value: "Cantidad", width: 90, sortable: true, type: "number", bgColor: "#0284C7" },
                { text: "Cant. Sticker", value: "CantSticker", width: 100, sortable: true, type: "number", bgColor: "#0284C7" },
                { text: "Marca", value: "Marca", width: 120, sortable: true, bgColor: "#0284C7" },
                { text: "Modelo", value: "Modelo", width: 120, sortable: true, bgColor: "#0284C7" },
                { text: "Serie", value: "Serie", width: 120, sortable: true, bgColor: "#0284C7" },
                { text: "Descripción Activo", value: "DescripcionActivo", width: 200, sortable: true, bgColor: "#0284C7" },
                { text: "Ubicación", value: "Ubicacion", width: 120, sortable: true, bgColor: "#0284C7" },
                { text: "Tipo Activo", value: "TipoActivo", width: 120, sortable: true, bgColor: "#0284C7" },
                { text: "Nueva Ubicación", value: "NewUbicacion", width: 140, sortable: true, bgColor: "#0284C7" },
                { text: "Serie Motor", value: "SerieMotor", width: 130, sortable: true, bgColor: "#0284C7" },
                { text: "Serie Chasis", value: "SerieChasis", width: 130, sortable: true, bgColor: "#0284C7" },
                { text: "Placa", value: "Placa", width: 90, sortable: true, bgColor: "#0284C7" },
                { text: "Condición", value: "Condicion", width: 110, sortable: true, bgColor: "#0284C7" },
                { text: "Usuario", value: "Usuario", width: 110, sortable: true, bgColor: "#0284C7" },
                { text: "Asignacion", value: "Asignacion", width: 110, sortable: true, bgColor: "#0284C7" },
                { text: "Cta. Contable", value: "cta_contable", width: 120, sortable: true, bgColor: "#8B4513" },
                { text: "Cta. Depr. Acum.", value: "cta_depr_acum", width: 140, sortable: true, bgColor: "#8B4513" },
                { text: "Asiento Ingreso", value: "asiento_ingreso", width: 130, sortable: true, bgColor: "#8B4513" },
                { text: "Clasificación AF", value: "Clasificacion_af", width: 130, sortable: true, bgColor: "#8B4513" },
                { text: "Clasif. AF Desc.", value: "Clasificacion_af_desc", width: 160, sortable: true, bgColor: "#8B4513" },
                { text: "Activo Fijo", value: "activo_fijo", width: 120, sortable: true, bgColor: "#8B4513" },
                { text: "Mejora", value: "mejora", width: 100, sortable: true, bgColor: "#8B4513" },
                { text: "Activo Mejora Desc.", value: "activo_mejora_desc", width: 160, sortable: true, bgColor: "#8B4513" },
                { text: "Tipo Activo AF", value: "tipo_activo_af", width: 130, sortable: true, bgColor: "#8B4513" },
                { text: "Descrip. Tipo Act.", value: "descrip_tipo_activo", width: 160, sortable: true, bgColor: "#8B4513" },
                { text: "Núm. Serie", value: "numero_serie", width: 120, sortable: true, bgColor: "#8B4513" },
                { text: "Saldo Inicial S/.", value: "saldoInicialSol", width: 130, sortable: true, type: "decimal", bgColor: "#8B4513" },
                { text: "Saldo Inicial $", value: "saldoInicialdol", width: 120, sortable: true, type: "decimal", bgColor: "#8B4513" },
                { text: "Adiciones S/.", value: "adicionesSol", width: 120, sortable: true, type: "decimal", bgColor: "#8B4513" },
                { text: "Adiciones $", value: "adicionesDol", width: 110, sortable: true, type: "decimal", bgColor: "#8B4513" },
                { text: "Retiros S/.", value: "retirosSol", width: 110, sortable: true, type: "decimal", bgColor: "#8B4513" },
                { text: "Retiros $", value: "retirosDol", width: 100, sortable: true, type: "decimal", bgColor: "#8B4513" },
                { text: "Valor Hist. S/.", value: "valor_historico_sol", width: 130, sortable: true, type: "decimal", bgColor: "#8B4513" },
                { text: "Valor Hist. $", value: "valor_historico_dol", width: 120, sortable: true, type: "decimal", bgColor: "#8B4513" },
                { text: "Valor Ajust. S/.", value: "valor_ajustado_Sol", width: 130, sortable: true, type: "decimal", bgColor: "#8B4513" },
                { text: "Fec. Adquisición", value: "fecha_adquisicion", width: 130, sortable: true, type: "date", bgColor: "#8B4513" },
                { text: "Proveedor", value: "proveedor", width: 110, sortable: true, bgColor: "#8B4513" },
                { text: "Nombre Prov.", value: "nombre_proveedor", width: 160, sortable: true, bgColor: "#8B4513" },
                { text: "Factura", value: "factura", width: 110, sortable: true, bgColor: "#8B4513" },
                { text: "Cód. Barras", value: "codigo_barras", width: 120, sortable: true, bgColor: "#8B4513" },
                { text: "Ubicación AF", value: "ubicacion_af", width: 120, sortable: true, bgColor: "#8B4513" },
                { text: "Agrupación", value: "agrupacion", width: 110, sortable: true, bgColor: "#8B4513" },
                { text: "Fec. Depreciación", value: "fecha_depreciacion", width: 140, sortable: true, type: "date", bgColor: "#8B4513" },
                { text: "Método Aplicado", value: "metodo_aplicado", width: 130, sortable: true, bgColor: "#8B4513" },
                { text: "Porcentaje %", value: "porcentaje", width: 110, sortable: true, type: "decimal", bgColor: "#8B4513" },
                { text: "Dep SI S/.", value: "dep_saldo_inicialsol", width: 110, sortable: true, type: "decimal", bgColor: "#8B4513" },
                { text: "Dep SI $", value: "dep_saldo_inicialdol", width: 100, sortable: true, type: "decimal", bgColor: "#8B4513" },
                { text: "Dep Adic. S/.", value: "dep_adicionessol", width: 110, sortable: true, type: "decimal", bgColor: "#8B4513" },
                { text: "Dep Adic. $", value: "dep_adicionesdol", width: 100, sortable: true, type: "decimal", bgColor: "#8B4513" },
                { text: "Dep Ret. S/.", value: "dep_retirossol", width: 100, sortable: true, type: "decimal", bgColor: "#8B4513" },
                { text: "Dep Ret. $", value: "dep_retirosdol", width: 100, sortable: true, type: "decimal", bgColor: "#8B4513" },
                { text: "Dep VH S/.", value: "dep_valor_historico_sol", width: 110, sortable: true, type: "decimal", bgColor: "#8B4513" },
                { text: "Dep VH $", value: "dep_valor_historico_dol", width: 100, sortable: true, type: "decimal", bgColor: "#8B4513" },
                { text: "Dep Val. Ajust. S/.", value: "dep_valor_ajustado_sol", width: 140, sortable: true, type: "decimal", bgColor: "#8B4513" },
                { text: "Subtipo Activo", value: "subtipo_activo", width: 120, sortable: true, bgColor: "#8B4513" },
                { text: "Índice Precio", value: "indice_precio", width: 110, sortable: true, type: "decimal", bgColor: "#8B4513" },
                { text: "Marca AF", value: "marca_af", width: 100, sortable: true, bgColor: "#8B4513" },
                { text: "Modelo AF", value: "modelo_af", width: 100, sortable: true, bgColor: "#8B4513" },
                { text: "Categoría", value: "categoria", width: 100, sortable: true, bgColor: "#8B4513" },
                { text: "Año Fab.", value: "anio_fabricacion", width: 90, sortable: true, type: "number", bgColor: "#8B4513" },
                { text: "Color", value: "color", width: 90, sortable: true, bgColor: "#8B4513" },
                { text: "Rubro 6 AF", value: "rubro6_af", width: 100, sortable: true, bgColor: "#8B4513" },
                { text: "Rubro 7 AF", value: "rubro7_af", width: 100, sortable: true, bgColor: "#8B4513" },
                { text: "Rubro 8 AF", value: "rubro8_af", width: 100, sortable: true, bgColor: "#8B4513" },
                { text: "Otros", value: "otros", width: 100, sortable: true, bgColor: "#8B4513" },
                { text: "Rubro 10 AF", value: "rubro10_af", width: 110, sortable: true, bgColor: "#8B4513" },
                { text: "Ubi. Descripción", value: "ubi_descripcion", width: 140, sortable: true, bgColor: "#8B4513" },
                { text: "Centro Costo", value: "centro_costo", width: 120, sortable: true, bgColor: "#8B4513" },
                { text: "Descrip. Tipo AF", value: "descrip_tipo_af", width: 140, sortable: true, bgColor: "#8B4513" },
                { text: "Valor Libros", value: "valor_libros", width: 120, sortable: true, type: "decimal", bgColor: "#8B4513" },
            ],
        };
    },
    computed: {
        dialogEvidenciaInfo() {
            if (!this.selectedItemEvidencia) return "";
            const codActivo = this.selectedItemEvidencia.CodigoActivo_Inventario || this.selectedItemEvidencia.CodigoActivo || "-";
            const codInv = this.selectedItemEvidencia.CodigoInventario || "-";
            const desc = this.selectedItemEvidencia.DescripcionActivo || this.selectedItemEvidencia.Descripcion || "";
            return `Activo: ${codActivo} | Inventario: ${codInv}${desc ? " | " + desc : ""}`;
        },
        kpiHasData() {
            return Array.isArray(this.items) && this.items.length > 0;
        },
        // definición centralizada de estados (para reutilizar en filtro y en KPIs)
        estadosDefinicion() {
            return [
                {
                    key: "faltante",
                    label: "Faltante",
                    icon: "mdi-alert-octagon",
                    color: "#B91C1C",
                    bg: "#FEF2F2",
                    border: "#FECACA",
                    filter: (it) => this.normalizeCondicion(it.Condicion) === "FALTANTE",
                },
                {
                    key: "inoperativo",
                    label: "Inoperativo",
                    icon: "mdi-power-off",
                    color: "#DC2626",
                    bg: "#FFF1F2",
                    border: "#FECDD3",
                    filter: (it) => this.normalizeCondicion(it.Condicion) === "INOPERATIVO",
                },
                {
                    key: "operativo_desuso",
                    label: "Operativo en desuso",
                    icon: "mdi-package-variant-closed",
                    color: "#B45309",
                    bg: "#FFFBEB",
                    border: "#FDE68A",
                    filter: (it) => this.normalizeCondicion(it.Condicion).includes("DESUSO"),
                },
                {
                    key: "pendiente_inventario",
                    label: "Pendiente",
                    icon: "mdi-clock-alert-outline",
                    color: "#64748B",
                    bg: "#F8FAFC",
                    border: "#CBD5E1",
                    filter: (it) => this.isNull(it.CodigoActivo_Inventario),
                },
                {
                    key: "operativo_uso",
                    label: "Operativo en uso",
                    icon: "mdi-check-decagram",
                    color: "#0F766E",
                    bg: "#F0FDFA",
                    border: "#99F6E4",
                    filter: (_it) => true,
                },
            ];
        },
        // label del estado seleccionado (para chips)
        estadoSeleccionadoLabel() {
            if (!this.selectedEstadoKey) return "";
            const def = this.estadosDefinicion.find(e => e.key === this.selectedEstadoKey);
            return def ? def.label : "";
        },
        // items filtrados según el estado seleccionado
        itemsFiltrados() {
            if (!this.selectedEstadoKey) return this.items;
            const def = this.estadosDefinicion.find(e => e.key === this.selectedEstadoKey);
            if (!def) return this.items;
            return this.items.filter(it => def.filter(it));
        },
        kpiTotalInventario() {
            if (!this.kpiHasData) return { unidades: 0, valor: 0 };
            const data = this.items;
            const unidades = data.length;
            const valor = data.reduce((acc, it) => acc + this.num(it.valor_libros), 0);
            return { unidades, valor };
        },
        kpiFaltantes() {
            if (!this.kpiHasData) return { unidades: 0, valor: 0 };
            const rows = this.items.filter(
                (it) => this.normalizeCondicion(it.Condicion) === "FALTANTE"
            );
            return this.sumUnidadesValor(rows);
        },
        kpiSobrantes() {
            if (!this.kpiHasData) return { unidades: 0, valor: 0 };
            const rows = this.items.filter(
                (it) => this.isNull(it.activo_fijo) && this.isNotNull(it.CodigoActivo_Inventario)
            );
            return this.sumUnidadesValor(rows);
        },
        kpiEstados() {
            if (!this.kpiHasData) return { rows: [], total: { unidades: 0, valor: 0 } };
            const data = this.items;
            const estadosDefinicion = this.estadosDefinicion;
            const assigned = new Set();
            const rows = estadosDefinicion
                .map((st) => {
                    const filtered = data.filter((it, idx) => {
                        if (assigned.has(idx)) return false;
                        const ok = st.filter(it);
                        if (ok) assigned.add(idx);
                        return ok;
                    });
                    const { unidades, valor } = this.sumUnidadesValor(filtered);
                    return {
                        key: st.key,
                        label: st.label,
                        icon: st.icon,
                        color: st.color,
                        bg: st.bg,
                        border: st.border,
                        unidades,
                        valor,
                    };
                })
                .filter((r) => true);

            // 🔹 CAMBIO CLAVE (OPCIÓN A): porcentaje según UNIDADES, no valor
            const totalUnidades = rows.reduce((s, r) => s + r.unidades, 0);
            const normalized = rows.map((r) => ({
                ...r,
                porcentaje: totalUnidades > 0 ? Math.round((r.unidades / totalUnidades) * 100) : 0,
            }));

            // Ajuste fino para que la suma sea exactamente 100
            let totalPorcentaje = normalized.reduce((s, r) => s + r.porcentaje, 0);
            if (totalPorcentaje !== 100 && normalized.length > 0) {
                const diff = 100 - totalPorcentaje;
                const biggest = normalized.reduce((a, b) => (a.unidades >= b.unidades ? a : b));
                biggest.porcentaje += diff;
            }

            return {
                rows: normalized,
                total: {
                    unidades: normalized.reduce((s, r) => s + r.unidades, 0),
                    valor: normalized.reduce((s, r) => s + r.valor, 0),
                },
            };
        },
        kpiEstadosTableRows() {
            return this.kpiEstados.rows;
        },
    },
    mounted() {
        this.cargarListaInventarios();
    },
    methods: {
        num(v) {
            if (v === null || v === undefined || v === "") return 0;
            const n = Number(v);
            return isNaN(n) ? 0 : n;
        },
        isNull(v) {
            if (v === null || v === undefined) return true;
            if (typeof v === "string") return v.trim() === "";
            return false;
        },
        isNotNull(v) {
            return !this.isNull(v);
        },
        normalizeCondicion(c) {
            if (c === null || c === undefined) return "";
            return String(c).trim().toUpperCase();
        },
        sumUnidadesValor(rows) {
            if (!Array.isArray(rows)) return { unidades: 0, valor: 0 };
            const unidades = rows.length;
            const valor = rows.reduce((acc, it) => acc + this.num(it.valor_libros), 0);
            return { unidades, valor };
        },
        formatKpiDecimal(v) {
            return this.formatDecimal(v);
        },
        formatKpiUnidades(v) {
            const n = this.num(v);
            return n.toLocaleString("es-PE");
        },
        formatDateTimeChat(value) {
            if (!value) return "";
            try {
                const m = this.$moment(value);
                const hoy = this.$moment().startOf("day");
                const fecha = m.startOf("day");
                const diff = hoy.diff(fecha, "days");
                let prefix = "";
                if (diff === 0) prefix = "Hoy ";
                else if (diff === 1) prefix = "Ayer ";
                return prefix + m.format("DD/MM/YYYY HH:mm");
            } catch (e) {
                return value;
            }
        },
        getImageSrc(imagenBase64) {
            if (!imagenBase64) return "";
            let b64 = imagenBase64;
            try { b64 = b64.toString(); } catch (e) {}
            if (/^data:image\//i.test(b64)) return b64;
            let mime = "image/jpeg";
            const head = b64.substring(0, 20).toUpperCase();
            if (head.startsWith("IVBO")) mime = "image/png";
            else if (head.startsWith("R0LG")) mime = "image/gif";
            else if (head.startsWith("QK3J") || head.startsWith("U0VR")) mime = "image/webp";
            else if (head.startsWith("SUKO")) mime = "image/bmp";
            const clean = b64.replace(/\s+/g, "");
            return "data:" + mime + ";base64," + clean;
        },
        normalizarEvidencia(raw) {
            if (!raw) return {};
            return {
                IdReporte: raw.IdReporte ?? raw.idReporte,
                CodigoActivo: raw.CodigoActivo ?? raw.codigoActivo,
                Esquema: raw.Esquema ?? raw.esquema,
                Mejora: raw.Mejora ?? raw.mejora,
                Usuario: raw.Usuario ?? raw.usuario,
                Observacion: raw.Observacion ?? raw.observacion,
                ImagenBase64: raw.ImagenBase64 ?? raw.imagenBase64 ?? raw.ImagenUrl ?? raw.imagenUrl,
                FechaRegistro: raw.FechaRegistro ?? raw.fechaRegistro,
                EstadoRegistro: raw.EstadoRegistro ?? raw.estadoRegistro,
                CodigoInventario: raw.CodigoInventario ?? raw.codigoInventario,
            };
        },
        abrirImagenCompleta(imagenBase64) {
            const src = this.getImageSrc(imagenBase64);
            if (!src) return;
            const win = window.open();
            if (win) {
                win.document.write(`
                    <!DOCTYPE html>
                    <html>
                    <head>
                        <title>Evidencia</title>
                        <style>
                            html, body {
                                margin: 0;
                                padding: 0;
                                height: 100%;
                                background: #0f172a;
                            }
                            body {
                                display: flex;
                                align-items: center;
                                justify-content: center;
                                overflow: auto;
                            }
                            img {
                                max-width: 100%;
                                max-height: 100vh;
                                object-fit: contain;
                                box-shadow: 0 0 30px rgba(0,0,0,0.4);
                            }
                        </style>
                    </head>
                    <body>
                        <img src="${src}" alt="Evidencia" />
                    </body>
                    </html>
                `);
                win.document.close();
            }
        },
        cerrarDialogEvidencias() {
            this.dialogEvidencias = false;
            this.listaEvidencias = [];
            this.selectedItemEvidencia = null;
            this.loadingEvidencias = false;
        },
        formatDateTime(value) {
            if (!value) return "";
            try {
                return this.$moment(value).format(this.$const.FormatDateTimeDB);
            } catch (e) {
                return value;
            }
        },
        formatDate(value) {
            if (!value) return "";
            try {
                return this.$moment(value).format(this.$const.FormatDateDB);
            } catch (e) {
                return value;
            }
        },
        formatDecimal(value) {
            if (value === null || value === undefined || value === "") return "";
            const num = Number(value);
            if (isNaN(num)) return value;
            return num.toLocaleString("es-PE", {
                minimumFractionDigits: 2,
                maximumFractionDigits: 2,
            });
        },
        formatCell(value, header) {
            if (value === null || value === undefined || value === "") return "";
            if (header && header.type) {
                switch (header.type) {
                    case "date":
                        return this.formatDate(value);
                    case "decimal":
                        return this.formatDecimal(value);
                    case "number":
                        return value;
                    default:
                        return value;
                }
            }
            return value;
        },
        cargarListaInventarios() {
            this.loadingInventarios = true;
            _sInventory.lista(this.$fun.getUserID()).then(
                (resp) => {
                    this.loadingInventarios = false;
                    const data = resp.data || [];
                    this.listaInventarios = data.map((item) => ({
                        ...item,
                        displayText: `${item.CodigoInventario} - ${this.formatDateTime(item.FechaRegistro)}`,
                    }));
                },
                () => {
                    this.loadingInventarios = false;
                    this.listaInventarios = [];
                    this.$fun.alert("No se pudo cargar la lista de inventarios.", "warning");
                }
            );
        },
        // alterna el filtro por estado
        toggleEstadoFiltro(key) {
            if (this.selectedEstadoKey === key) {
                this.selectedEstadoKey = null;
            } else {
                this.selectedEstadoKey = key;
            }
        },
        buscar() {
            if (!this.selectedInventario) {
                this.$fun.alert("Seleccione un código de inventario", "warning");
                return;
            }
            const codigo = this.selectedInventario.CodigoInventario || this.selectedInventario;
            this.loadingData = true;
            this.processing = true;
            this.items = [];
            // resetear filtro al buscar
            this.selectedEstadoKey = null;
            _sInventory.activoFijo(codigo, this.$fun.getUserID()).then(
                (resp) => {
                    this.loadingData = false;
                    this.processing = false;
                    const data = resp.data;
                    if (Array.isArray(data)) {
                        this.items = data;
                    } else if (data && (Array.isArray(data.list) || Array.isArray(data.data) || Array.isArray(data.result))) {
                        this.items = data.list || data.data || data.result || [];
                    } else if (data) {
                        this.items = [data];
                    } else {
                        this.items = [];
                    }
                    if (this.items.length === 0) {
                        this.$fun.alert("No se encontraron datos para el inventario seleccionado.", "info");
                    }
                },
                (e) => {
                    this.loadingData = false;
                    this.processing = false;
                    const msg = e && e.response && e.response.data && e.response.data.Message
                        ? e.response.data.Message
                        : "Error al cargar los datos del inventario.";
                    this.$fun.alert(msg, "error");
                }
            );
        },
        verEvidencias(item) {
            const codigoActivo = item.CodigoActivo_Inventario || item.CodigoActivo || "";
            const codigoInv = item.CodigoInventario || (this.selectedInventario && this.selectedInventario.CodigoInventario) || "";
            if (!codigoActivo || !codigoInv) {
                this.$fun.alert("No se pudo identificar el activo o el inventario.", "warning");
                return;
            }
            this.selectedItemEvidencia = item;
            this.dialogEvidencias = true;
            this.loadingEvidencias = true;
            this.listaEvidencias = [];
            this.$nextTick(() => {
                if (this.$refs.evidenciaScroll) {
                    this.$refs.evidenciaScroll.scrollTop = 0;
                }
            });
            _sInventory.evidenciaBase64(codigoActivo, codigoInv, this.$fun.getUserID()).then(
                (resp) => {
                    this.loadingEvidencias = false;
                    const raw = resp.data;
                    let data = [];
                    if (Array.isArray(raw)) {
                        data = raw;
                    } else if (raw) {
                        if (Array.isArray(raw.list)) data = raw.list;
                        else if (Array.isArray(raw.data)) data = raw.data;
                        else if (Array.isArray(raw.result)) data = raw.result;
                        else data = [raw];
                    }
                    this.listaEvidencias = data
                        .map(this.normalizarEvidencia)
                        .sort((a, b) => {
                            const fa = a.FechaRegistro ? new Date(a.FechaRegistro).getTime() : 0;
                            const fb = b.FechaRegistro ? new Date(b.FechaRegistro).getTime() : 0;
                            return fa - fb;
                        });
                },
                (e) => {
                    this.loadingEvidencias = false;
                    this.listaEvidencias = [];
                    const msg = e && e.response && e.response.data && e.response.data.Message
                        ? e.response.data.Message
                        : "Error al cargar las evidencias.";
                    this.$fun.alert(msg, "error");
                }
            );
        },
        exportarExcel() {
            // exportar solo lo filtrado
            const dataExport = this.itemsFiltrados;
            if (!dataExport || dataExport.length === 0) {
                this.$fun.alert("No hay datos para exportar.", "warning");
                return;
            }
            const codigoInv = this.selectedInventario && this.selectedInventario.CodigoInventario
                ? this.selectedInventario.CodigoInventario
                : "";
            const exportHeaders = this.headers.map((h) => ({
                h: h.value,
                t: h.text,
                bgColor: h.bgColor || "#8B4513",
                width: h.width || 100,
            }));
            const headerHTML = exportHeaders
                .map(({ t, bgColor, width }) => {
                    return `<th style="background-color:${bgColor};color:#FFFFFF;font-weight:bold;border:1px solid #000000;padding:8px;text-align:center;font-size:11pt;font-family:Calibri;width:${width}px;white-space:nowrap;">${t}</th>`;
                })
                .join("");
            const rowsHTML = dataExport
                .map((row) => {
                    const cells = exportHeaders
                        .map(({ h }) => {
                            const meta = this.headers.find((x) => x.value === h);
                            let val = row[h];
                            if (meta && meta.type === "date") {
                                val = this.formatDate(val);
                            } else if (meta && meta.type === "decimal") {
                                val = val === null || val === undefined || val === "" ? "" : Number(val);
                                if (val !== "" && !isNaN(val)) {
                                    val = Number(val).toLocaleString("es-PE", {
                                        minimumFractionDigits: 2,
                                        maximumFractionDigits: 2,
                                    });
                                }
                            } else if (meta && meta.value === "ContImg") {
                                val = val === null || val === undefined || val === "" ? 0 : Number(val);
                            }
                            if (val === null || val === undefined) val = "";
                            return `<td style="border:1px solid #AAAAAA;padding:4px;text-align:center;font-size:11pt;font-family:Calibri;mso-number-format:'\\@';">${val}</td>`;
                        })
                        .join("");
                    return `<tr>${cells}</tr>`;
                })
                .join("");
            const colStyles = exportHeaders
                .map(({ width }) => `<col style="width:${width}px;">`)
                .join("");
            const html = `
                <html xmlns:o="urn:schemas-microsoft-com:office:office" xmlns:x="urn:schemas-microsoft-com:office:excel" xmlns="http://www.w3.org/TR/REC-html40">
                <head>
                    <meta charset="utf-8">
                    <!--[if gte mso 9]>
                    <xml>
                        <x:ExcelWorkbook>
                            <x:ExcelWorksheets>
                                <x:ExcelWorksheet>
                                    <x:Name>Inventario</x:Name>
                                    <x:WorksheetOptions>
                                        <x:DisplayGridlines/>
                                        <x:FreezePanes/>
                                        <x:FrozenNoSplit/>
                                        <x:SplitHorizontal>1</x:SplitHorizontal>
                                        <x:TopRowBottomPane>1</x:TopRowBottomPane>
                                        <x:ActivePane>2</x:ActivePane>
                                    </x:WorksheetOptions>
                                </x:ExcelWorksheet>
                            </x:ExcelWorksheets>
                            <x:Styles>
                                <x:Style>
                                    <x:Name>Normal</x:Name>
                                    <x:Font>
                                        <x:FontName>Calibri</x:FontName>
                                        <x:Size>11</x:Size>
                                    </x:Font>
                                </x:Style>
                            </x:Styles>
                        </x:ExcelWorkbook>
                    </xml>
                    <![endif]-->
                    <style>
                        table { border-collapse: collapse; }
                        body, table, thead, tbody, tr, th, td {
                            font-family: Calibri, Arial, sans-serif;
                            font-size: 11pt;
                            mso-line-height-rule: exactly;
                        }
                    </style>
                </head>
                <body>
                    <table border="1">
                        <colgroup>${colStyles}</colgroup>
                        <thead>
                            <tr>${headerHTML}</tr>
                        </thead>
                        <tbody>
                            ${rowsHTML}
                        </tbody>
                    </table>
                </body>
                </html>`;
            const blob = new Blob(["\ufeff", html], { type: "application/vnd.ms-excel" });
            const link = document.createElement("a");
            const url = URL.createObjectURL(blob);
            link.href = url;
            const suffix = this.selectedEstadoKey ? "_" + this.selectedEstadoKey : "";
            const name = "InventarioContable" + (codigoInv ? "_" + codigoInv : "") + suffix + ".xls";
            link.download = name;
            document.body.appendChild(link);
            link.click();
            document.body.removeChild(link);
            URL.revokeObjectURL(url);
        },
    },
};
</script>

<style>
.tran {
    opacity: 0.7 !important;
}
.con-inventory-table >>> .v-data-table-header {
    background-color: transparent !important;
}
.con-inventory-table >>> .v-data-table-header tr th {
    padding: 0 !important;
    border: 1px solid rgba(0, 0, 0, 0.12);
}
.con-inventory-table >>> table {
    border-collapse: separate !important;
}
.con-inventory-table >>> tbody td {
    border: 1px solid rgba(0, 0, 0, 0.06);
    padding: 4px 6px !important;
    font-size: 11px;
}

.evidencia-card {
    border-radius: 16px !important;
    overflow: hidden;
}
.evidencia-header {
    background: linear-gradient(135deg, #0284C7 0%, #0369A1 100%);
    position: relative;
}
.evidencia-header::after {
    content: "";
    position: absolute;
    top: 0;
    right: 0;
    width: 120px;
    height: 100%;
     background-size: contain;
    pointer-events: none;
}
.evidencia-body {
    background: linear-gradient(180deg, #F8FAFC 0%, #F1F5F9 100%);
    min-height: 350px;
    max-height: 550px;
}
.evidencia-chat {
    gap: 0;
}
.evidencia-message {
    animation: fadeInUp 0.35s ease-out both;
}
@keyframes fadeInUp {
    from {
        opacity: 0;
        transform: translateY(12px);
    }
    to {
        opacity: 1;
        transform: translateY(0);
    }
}
.evidencia-img {
    width: 300px !important;
    max-width: 300px !important;
}
.evidencia-bubble {
    background: #FFFFFF;
    border: 1px solid #E2E8F0;
    border-radius: 14px;
    padding: 14px 16px;
    box-shadow: 0 1px 3px rgba(15, 23, 42, 0.04), 0 1px 2px rgba(15, 23, 42, 0.03);
    transition: box-shadow 0.2s ease, transform 0.2s ease;
    position: relative;
}
.evidencia-bubble::before {
    content: "";
    position: absolute;
    top: 14px;
    left: -8px;
    width: 0;
    height: 0;
    border-top: 8px solid transparent;
    border-bottom: 8px solid transparent;
    border-right: 8px solid #FFFFFF;
    filter: drop-shadow(-1px 0 0 #E2E8F0);
}
.evidencia-bubble:hover {
    box-shadow: 0 4px 12px rgba(15, 23, 42, 0.08), 0 2px 4px rgba(15, 23, 42, 0.04);
}
.evidencia-image-wrapper {
    position: relative;
    cursor: zoom-in;
    border-radius: 12px;
    overflow: hidden;
    transition: transform 0.2s ease;
    width: 300px;
    max-width: 300px;
}
.evidencia-image-wrapper:hover {
    transform: translateY(-1px);
}
.evidencia-image-wrapper::after {
    content: "";
    position: absolute;
    inset: 0;
    background: linear-gradient(180deg, transparent 60%, rgba(0, 0, 0, 0.15) 100%);
    pointer-events: none;
    opacity: 0;
    transition: opacity 0.2s ease;
}
.evidencia-image-wrapper:hover::after {
    opacity: 1;
}
.evidencia-image-zoom {
    position: absolute;
    top: 10px;
    right: 10px;
    background: rgba(2, 132, 199, 0.9);
    backdrop-filter: blur(4px);
    padding: 5px 8px;
    border-radius: 8px;
    display: flex;
    align-items: center;
    justify-content: center;
    opacity: 0;
    transform: translateY(-4px);
    transition: opacity 0.2s ease, transform 0.2s ease;
    z-index: 2;
}
.evidencia-image-wrapper:hover .evidencia-image-zoom {
    opacity: 1;
    transform: translateY(0);
}
.evidencia-img >>> .v-image__image {
    transition: transform 0.4s ease;
}
.evidencia-img:hover >>> .v-image__image {
    transform: scale(1.02);
}
.evidencia-observacion {
    background: linear-gradient(135deg, #EFF6FF 0%, #E0F2FE 100%);
    border-left: 3px solid #0284C7;
    border-radius: 0 10px 10px 0;
}
.evidencia-observacion:empty {
    display: none;
}

.kpi-row >>> .v-col {
    transition: all 0.3s ease;
}
.kpi-card {
    position: relative;
    overflow: hidden;
    transition: transform 0.25s ease, box-shadow 0.25s ease;
    animation: kpiFadeIn 0.45s ease-out both;
}
@keyframes kpiFadeIn {
    from { opacity: 0; transform: translateY(12px); }
    to { opacity: 1; transform: translateY(0); }
}
.kpi-card:hover {
    transform: translateY(-2px);
    box-shadow: 0 12px 28px -10px rgba(15, 23, 42, 0.18) !important;
}
.kpi-card-top {
    position: relative;
}
.kpi-card-top::after {
    content: "";
    position: absolute;
    top: -20px;
    right: -20px;
    width: 140px;
    height: 140px;
    background: url("data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 100 100'%3E%3Ccircle cx='50' cy='50' r='50' fill='%23ffffff' fill-opacity='0.06'/%3E%3Ccircle cx='70' cy='30' r='20' fill='%23ffffff' fill-opacity='0.05'/%3E%3C/svg%3E") no-repeat center;
    background-size: contain;
    pointer-events: none;
}
.kpi-card-metrics .tabular-nums,
.kpi-table .tabular-nums {
    font-variant-numeric: tabular-nums;
    font-feature-settings: "tnum" 1;
}
.kpi-divider-left {
    border-left: 1px solid #E2E8F0;
}
@media (max-width: 767px) {
    .kpi-divider-left {
        border-left: none;
        border-top: 1px solid #E2E8F0;
        padding-top: 12px !important;
        margin-top: 12px !important;
    }
}
.kpi-hallazgo-box {
    transition: transform 0.2s ease, box-shadow 0.2s ease;
    position: relative;
}
.kpi-hallazgo-box:hover {
    transform: translateY(-2px);
    box-shadow: 0 8px 18px -8px rgba(0,0,0,0.12);
}
.kpi-table {
    border-collapse: collapse;
    table-layout: fixed;
}
.kpi-table >>> * {
    box-sizing: border-box;
}
.kpi-estados-row {
    animation: kpiStateRowFade 0.35s ease-out both;
    transition: background 0.18s ease;
}
.kpi-estados-row:hover {
    background: #F0FDFA !important;
}
@keyframes kpiStateRowFade {
    from { opacity: 0; transform: translateX(-8px); }
    to { opacity: 1; transform: translateX(0); }
}
.kpi-skeleton .kpi-card-metrics,
.kpi-skeleton .pa-4,
.kpi-skeleton >>> .v-progress-linear__content {
    filter: blur(0.3px);
}
@media (max-width: 767px) {
    .kpi-col-left,
    .kpi-col-right {
        padding: 0 !important;
    }
}

/* estilos para la fila seleccionada de la tabla de estados */
.kpi-estados-row {
    cursor: pointer;
}
.kpi-estado-selected {
    background: #CCFBF1 !important;
    box-shadow: inset 4px 0 0 #0F766E;
}
.kpi-estado-selected:hover {
    background: #99F6E4 !important;
}
</style>